var _defs, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 148.92,
    x2: 362.59,
    y1: 603.59,
    y2: 389.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    fill: "#1c8adb",
    "data-name": "circle4174"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m261.62 779.62 197.51-197.51v-32.081l152.86-152.86-105.68-81.146-79.861 79.861-19.683-2.5206 4.9868-4.9868 47.379-47.379v-123.11h-213.24l-244.25 244.25c29.321 166.7 122.54 265.62 259.98 317.48z",
    fill: "url(#c)",
    opacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "m611.99 397.17-105.68-81.146v63.13a20.67 20.67 0 0 0 -5.6614 -0.8545h-130.21a20.758 20.758 0 1 0 0 41.517h130.21a20.728 20.728 0 0 0 5.6614 -0.8545v59.356l105.68-81.146zm-152.86-179.28h-213.24v364.21h213.24v-117.53h-37.742v72.418h-137.76v-273.99h137.76v77.991h37.742v-123.11z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.8335d7cabc38fcd925c09bc3b5dc6432.svg";
export { ForwardRef as ReactComponent };